import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 환불정책 (Refund Policy)
 */
export default function RefundPolicyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page" style={{ background: 'var(--bg)', paddingBottom: 'calc(40px + var(--safe-bottom))' }}>
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'var(--surface)',
          borderBottom: '1px solid var(--border)',
          padding: 'calc(var(--safe-top) + 14px) 20px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          minHeight: 56,
        }}
      >
        <button className="back-btn" onClick={() => navigate(-1)} aria-label="뒤로 가기">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="page-header-title">환불정책</div>
        <div style={{ width: 36 }} />
      </header>

      <main style={{ padding: '24px 20px 40px', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 8 }}>
            환불정책
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text-tertiary)', lineHeight: 1.6 }}>
            스마트오더는 소비자 보호를 위해 다음과 같은 환불 기준을 적용합니다.
          </p>
        </div>

        <Section title="1. 환불 가능 시점">
          <p>
            주문하신 메뉴는 아래 시점에 한하여 환불이 가능합니다. 조리의 성격상 가공이 개시된 음식물은
            「전자상거래 등에서의 소비자 보호에 관한 법률」 제17조 제2항 제3호(용역 또는 디지털콘텐츠 등의 제공이
            개시된 경우)에 준하여 원칙적으로 청약철회가 제한됩니다.
          </p>
          <ul className="refund-list">
            <li><strong>조리 시작 전</strong>: 전액 환불 가능</li>
            <li><strong>조리 시작 후</strong>: 원칙적으로 환불 불가 (단, 매장 귀책사유는 예외)</li>
            <li><strong>서빙 완료 후</strong>: 음식의 하자, 위생 문제 등 매장 귀책사유가 있는 경우에 한하여 환불 가능</li>
          </ul>
        </Section>

        <Section title="2. 환불 사유별 처리">
          <div className="refund-card">
            <div className="refund-card-title">가. 고객 단순 변심</div>
            <div className="refund-card-body">
              조리 시작 전에 한해 전액 환불 가능합니다. 조리가 시작된 이후에는 환불이 제한될 수 있습니다.
            </div>
          </div>
          <div className="refund-card">
            <div className="refund-card-title">나. 매장 귀책사유 (누락, 오조리, 위생 불량 등)</div>
            <div className="refund-card-body">
              전액 환불 또는 재조리 처리됩니다. 이 경우 환불 처리는 조리 단계와 관계없이 가능합니다.
            </div>
          </div>
          <div className="refund-card">
            <div className="refund-card-title">다. 시스템 오류 (이중결제, 결제 금액 오류)</div>
            <div className="refund-card-body">
              확인 즉시 전액 환불 처리됩니다. 결제 대행사의 승인 취소 절차에 따라 결제 수단별 환불 소요 기간이
              발생할 수 있습니다.
            </div>
          </div>
          <div className="refund-card">
            <div className="refund-card-title">라. 주문 취소 또는 매장 사정</div>
            <div className="refund-card-body">
              매장에서 주문을 수락하지 못하거나 조리가 어려운 경우 전액 환불 처리됩니다.
            </div>
          </div>
        </Section>

        <Section title="3. 환불 방법">
          <ol className="refund-ol">
            <li>주문 상세 화면에서 "환불 요청" 버튼을 통해 신청하실 수 있습니다.</li>
            <li>매장 담당자에게 직접 요청하시거나 직원 호출 기능을 이용해 주세요.</li>
            <li>결제 대행사를 통한 자동 환불 또는 매장 수기 환불로 처리됩니다.</li>
            <li>환불은 원칙적으로 결제하신 수단과 동일한 경로로 이루어집니다.</li>
          </ol>
        </Section>

        <Section title="4. 환불 처리 기간">
          <ul className="refund-list">
            <li>신용카드 결제: 승인 취소 시 즉시 반영되며, 카드사 정책에 따라 영업일 기준 3~7일 소요</li>
            <li>체크카드 결제: 영업일 기준 3~5일 이내</li>
            <li>간편결제(카카오페이, 토스페이 등): 영업일 기준 1~3일 이내</li>
            <li>계좌이체: 영업일 기준 2~5일 이내</li>
          </ul>
          <p style={{ marginTop: 8, fontSize: 13, color: 'var(--text-tertiary)' }}>
            위 기간은 결제사 및 금융기관 사정에 따라 달라질 수 있습니다.
          </p>
        </Section>

        <Section title="5. 분쟁 조정 절차">
          <p>
            환불 요청이 정상적으로 처리되지 않거나 매장과의 이견이 발생한 경우, 다음 절차에 따라 분쟁 조정을
            신청하실 수 있습니다.
          </p>
          <ol className="refund-ol">
            <li>고객지원 페이지 또는 고객센터를 통해 1차 민원 접수</li>
            <li>사실관계 확인 및 매장 의견 청취 (영업일 기준 3일 이내 1차 회신)</li>
            <li>회사의 중재를 통한 합의 도출</li>
            <li>합의 불성립 시 한국소비자원, 전자거래분쟁조정위원회 등 외부 기관에 조정 신청</li>
          </ol>
        </Section>

        <Section title="6. 소비자 보호기관 연락처">
          <div
            style={{
              background: 'var(--primary-light)',
              padding: 16,
              borderRadius: 12,
              fontSize: 13,
              lineHeight: 1.8,
              color: 'var(--text-secondary)',
            }}
          >
            <div><strong>한국소비자원</strong> · 국번없이 1372 · www.kca.go.kr</div>
            <div><strong>전자거래분쟁조정위원회</strong> · 1661-5714 · www.ecmc.or.kr</div>
            <div><strong>금융감독원 콜센터</strong> · 국번없이 1332 · www.fss.or.kr</div>
          </div>
        </Section>
      </main>

      <style>{`
        .refund-list {
          padding-left: 20px;
          margin: 8px 0;
        }
        .refund-list li {
          font-size: 14px;
          color: var(--text-secondary);
          line-height: 1.8;
          margin-bottom: 4px;
        }
        .refund-ol {
          padding-left: 22px;
          margin: 8px 0;
        }
        .refund-ol li {
          font-size: 14px;
          color: var(--text-secondary);
          line-height: 1.8;
          margin-bottom: 4px;
        }
        .refund-card {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 12px;
          padding: 14px 16px;
          margin-bottom: 10px;
        }
        .refund-card-title {
          font-size: 14px;
          font-weight: 700;
          color: var(--text);
          margin-bottom: 4px;
        }
        .refund-card-body {
          font-size: 13px;
          color: var(--text-secondary);
          line-height: 1.7;
        }
      `}</style>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 10, letterSpacing: '-0.3px' }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.75 }}>
        {children}
      </div>
    </section>
  );
}
